var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnDecrease(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#C8E4FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.54596 16.0833C6.28346 16.0833 6.08901 15.9958 5.96262 15.8208C5.83624 15.6458 5.82165 15.4319 5.91887 15.1791L8.39804 8.58746C8.47582 8.40274 8.6096 8.24485 8.79937 8.11379C8.98876 7.98235 9.18554 7.91663 9.38971 7.91663C9.58415 7.91663 9.77374 7.98235 9.95846 8.11379C10.1432 8.24485 10.2744 8.40274 10.3522 8.58746L12.8168 15.1645C12.914 15.4173 12.902 15.6337 12.7806 15.8138C12.6589 15.9935 12.4571 16.0833 12.1751 16.0833C12.0682 16.0833 11.9612 16.0467 11.8543 15.9736C11.7473 15.9009 11.6744 15.8111 11.6355 15.7041L11.023 13.9979H7.72721L7.12929 15.6895C7.0904 15.7965 7.01515 15.8888 6.90354 15.9666C6.79154 16.0444 6.67235 16.0833 6.54596 16.0833ZM8.15012 12.8166H10.6001L9.40429 9.43329H9.34596L8.15012 12.8166ZM14.3335 12.5833C14.1682 12.5833 14.0297 12.5273 13.9181 12.4153C13.8061 12.3037 13.7501 12.1652 13.7501 12C13.7501 11.8347 13.8061 11.696 13.9181 11.584C14.0297 11.4724 14.1682 11.4166 14.3335 11.4166H17.8335C17.9987 11.4166 18.1372 11.4724 18.2488 11.584C18.3608 11.696 18.4168 11.8347 18.4168 12C18.4168 12.1652 18.3608 12.3037 18.2488 12.4153C18.1372 12.5273 17.9987 12.5833 17.8335 12.5833H14.3335Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnDecrease);
export default __webpack_public_path__ + "static/media/btn_decrease.63373002c8eb2aad5f91ff4422d4bff6.svg";
export { ForwardRef as ReactComponent };